import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ChartOptions, ChartData } from 'chart.js';
import 'chartjs-adapter-date-fns';
import { ChartSeries, ChartPeriod, ChartReferenceLine } from '../interfaces/chart-data.interface';
import { buildReferenceLineAnnotations } from '../utils/chart-helpers';

@Component({
  selector: 'app-noise-line-chart',
  imports: [BaseChartDirective],
  templateUrl: './noise-line-chart.html',
  styleUrl: './noise-line-chart.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoiseLineChart {
  seriesData = input.required<ChartSeries[]>();
  period = input<ChartPeriod>('1d');
  referenceLines = input<ChartReferenceLine[]>([]);

  chartData = computed<ChartData<'line'>>(() => {
    const series = this.seriesData();
    if (series.length === 0) {
      return { datasets: [] };
    }

    const datasets = series.map((s, index) => ({
      data: s.data.map(d => ({ x: d.timestamp.getTime(), y: d.value })),
      label: s.label,
      borderColor: s.color || (index === 0 ? 'var(--md-sys-color-primary)' : 'var(--md-sys-color-secondary)'),
      backgroundColor: s.color || (index === 0 ? 'var(--md-sys-color-primary)' : 'var(--md-sys-color-secondary)'),
      fill: false,
      tension: 0.1,
      pointRadius: 2,
    }));

    return { datasets };
  });

  chartOptions = computed<ChartOptions<'line'>>(() => {
    const annotations = buildReferenceLineAnnotations(this.referenceLines());
    const currentPeriod = this.period();
    const tooltipFormat = currentPeriod === '1d' ? 'HH:mm' : 'MM/dd HH:mm';

    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'top',
        },
        annotation: {
          annotations
        },
        tooltip: {
          mode: 'index',
          intersect: false,
        }
      },
      scales: {
        x: {
          type: 'time',
          time: {
            tooltipFormat,
            displayFormats: {
              minute: 'HH:mm',
              hour: 'HH:mm',
              day: 'MM/dd'
            }
          },
          display: true,
          grid: {
            display: false
          }
        },
        y: {
          display: true,
          beginAtZero: true,
          title: {
            display: true,
            text: '騒音 (dB)'
          }
        }
      }
    };
  });
}
